import type { Breadcrumb } from '@/types/page';

export const transformBreadcrumb = (breadcrumb: Breadcrumb, name: string) => {
  const transformedCrumbs: Breadcrumb = {
    name,
  };

  if (breadcrumb.parents) {
    transformedCrumbs.parents = [...breadcrumb.parents, { name: breadcrumb.name, slug: breadcrumb.slug }];
  }

  return transformedCrumbs;
};
